export default __webpack_public_path__ + "static/media/STEM.18fd407a.jpeg";